import { NavLink } from "react-router";
import { LessonId } from "../enums/lessonId";
import { useNavigate } from "react-router";

interface ILessonCardProps {
    image: any;
    title: string;
    lessonId: LessonId;
}

const LessonCard = ({ image, title, lessonId }: ILessonCardProps) => {
    const navigate = useNavigate();

    return (
        <div className="card card-custom border-white border-0" onClick={() => navigate(`/lessons/${lessonId}`)}>
            <div className="card-custom-img" style={{ backgroundImage: `url(${image})` }}></div>
            <h5 className="title-font">{title}</h5>
            <NavLink className={"dropdown-item text-color link-text"} style={{ fontSize: 14 }} to={`/lessons/${lessonId}`}>...Read more</NavLink>
        </div>
    );
}

export default LessonCard;
